import { createStyles, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';
import FsBody from './FsBody';

const FsErrorText = withStyles(({ palette }) =>
  createStyles({
    root: {
      fontSize: 14,
      color: palette.error.main,
    },
  })
)((props: TypographyAllProps) => <FsBody {...props} />);

export default FsErrorText;
